// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__81sVd","col":"styles_col__2IFdL"};